/**
 * pdf.js extra fonts — the ones a PDF is allowed not to embed.
 *
 * Resolved against this module's own URL, which is the only address that is
 * right in all three shells. `window.location.origin` is not: joined to a
 * relative Vite `base` it produces `https://host./`, which is not a URL at all
 * and throws — and this is a module-level constant, so the throw happens on
 * import and takes the whole app down with it, not just the PDF preview. On
 * Electron's `file://` origin the same expression is the string `"null"`, which
 * cannot be a base either.
 *
 * The `..` steps out of Vite's `assets/` directory to the bundle root, where
 * the `pdfjsStandardFonts` plugin in vite.config.ts emits the fonts. In dev
 * there is no such directory and the path lands under `/src/`, which the same
 * plugin's middleware still answers: it matches on the substring and serves by
 * basename precisely so the prefix does not have to be predicted.
 */
// Vite may normalize a directory asset URL without its trailing slash; pdf.js
// requires it before resolving individual font files.
export const standardFontDataUrl = new URL('../pdfjs/standard_fonts/', import.meta.url).href.replace(/\/?$/, '/');
